import React, { useRef, useState, useEffect } from "react";
import Textbox from "carbon-react/lib/__experimental__/components/textbox";
import StepTitle from "../../../../common/stepTitle/StepTitle";
import DialogConfirmButtons from "../../../../common/dialogConfirmButtons/DialogConfirmButtons";
import SuccessMessage from "../../../../messages/SuccessMessage";
import ConfirmDialog from "../../../../common/confirmDialog/ConfirmDialog";

const EnterCodeStep = ({
  user,
  busy,
  state,
  onStateChanged,
  onCancel,
  onCompleted,
}) => {
  const validationCodeInputRef = useRef(null);
  const [confirmResetOpen, setConfirmResetOpen] = useState(false);

  useEffect(() => {
    //  Set focus to the validation code input element
    if (!busy && isAValidFunc(validationCodeInputRef?.current?.focus)) {
      validationCodeInputRef.current.focus();
    }
  }, [busy]);

  const isAValidFunc = (func) => {
    return func && typeof func === "function";
  };

  const onCancelClicked = () => {
    if (isAValidFunc(onCancel)) onCancel();
  };

  const performMfaReset = () => {
    if (!validateStep()) return;
    if (isAValidFunc(onCompleted)) onCompleted();
  };

  const validateStep = () => {
    let result = true;
    if (!validateVerificationCode()) result = false;
    return result;
  };

  const validateVerificationCode = () => {
    const valid =
      state.verificationCode && state.verificationCode.length > 0
        ? true
        : false;
    updateState(() => {
      state.verificationCodeValid = valid;
    });
    return valid;
  };

  const onConfirmResetCancel = () => {
    setConfirmResetOpen(false);
  };

  const onConfirmResetContinue = async () => {
    setConfirmResetOpen(false);
    await performMfaReset();
  };

  const verificationCodeWarningAttributes = {
    hasWarning: true,
    inputIcon: "warning",
    tooltipMessage: "Please enter a valid code",
  };

  const onVerificationCodeChanged = (code) => {
    const sanitizedCode = code && code.length > 0 ? code.trim() : "";
    updateState(() => {
      state.verificationCode = sanitizedCode;
      state.verificationCodeValid = true;
    });
  };

  const updateState = (mutateState) => {
    if (isAValidFunc(mutateState)) mutateState();
    onStateChanged({ ...state });
  };

  const verificationCodeInput = (
    <div className="reset-mfa-enrollment-verification-code">
      <Textbox
        id="reset-mfa-enrollment-verification-code"
        label="Verification code"
        disabled={busy}
        value={state?.verificationCode}
        inputRef={(e) => {
          validationCodeInputRef.current = e?.current;
        }}
        onChange={(e) => {
          onVerificationCodeChanged(e.target.value);
        }}
        onBlur={validateVerificationCode}
        {...(!state.verificationCodeValid
          ? verificationCodeWarningAttributes
          : {})}
      />
    </div>
  );

  const buttons = (
    <DialogConfirmButtons
      appearBusy={busy}
      confirmBtnEnabled={true}
      confirmBtnLabel="Reset"
      onConfirm={() => {
        setConfirmResetOpen(true);
      }}
      onCancel={onCancelClicked}
    />
  );

  const confirmDeletion = (
    <ConfirmDialog
      open={confirmResetOpen}
      prompt="Are you sure you want to reset MFA enrollments? This action can’t be reversed."
      confirmBtnLabel="Reset"
      onCancel={onConfirmResetCancel}
      onConfirm={onConfirmResetContinue}
    />
  );

  return (
    <div id="enter-code-step" className="reset-mfa-enrollment-enter-code-step">
      <div className="-access-step-body">
        <SuccessMessage
          className="code-sent-success-message"
          message={`Verification code was sent to ${user?.email}`}
        />
        <StepTitle title="Enter verification code" />
        {verificationCodeInput}
      </div>
      {buttons}
      {confirmDeletion}
    </div>
  );
};

export default EnterCodeStep;
